/** Label lookup for Scope 3 GHG emission category keys used in breakdown tables. */
export const scope3CategoriesNb: Record<string, string> = {
  purchasedGoods: "Innkjøpte varer og tjenester",
  capitalGoods: "Kapitalvarer",
  fuelEnergyRelated: "Brensel- og energirelaterte aktiviteter",
  upstreamTransport: "Oppstrøms transport og distribusjon",
  wasteOperations: "Avfall generert i driften",
  businessTravel: "Forretningsreiser",
  employeeCommuting: "Ansattes pendling",
  upstreamLeased: "Oppstrøms leasede eiendeler",
  downstreamTransport: "Nedstrøms transport og distribusjon",
  processingSold: "Bearbeiding av solgte produkter",
  useSold: "Bruk av solgte produkter",
  endOfLifeSold: "Sluttbehandling av solgte produkter",
  downstreamLeased: "Nedstrøms leasede eiendeler",
  franchises: "Franchiser",
  investments: "Investeringer",
}

/** Select options for Scope 3 GHG emission category dropdowns. */
export const scope3CategoryOptionsNb = Object.entries(scope3CategoriesNb).map(([code, name]) => ({
  code,
  name,
}))
